import { Alert } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import Modal from '../../elements/Modal';
import ExpertAdviceForm from './ExpertAdviceForm';

const AddExpertAdvice = ({
  data,
  fetchData,
  setMessage,
  setSnackbarOpen,
  token,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    const formData = new FormData();
    const expertName = values.name.charAt(0).toUpperCase() + values.name.slice(1);
    formData.append('name', expertName);
    formData.append('description', values.description);
    formData.append('image', values.image);
    formData.append('designation', values.designation);
    formData.append('tiktokId', values.tiktokId);
    formData.append('twitterId', values.twitterId);
    formData.append('instagramId', values.instagramId);
    formData.append('categoryId', data.id);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/experts`,
        {
          method: 'POST',
          body: formData,
          headers: { Authorization: token },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Expert added successfully');
      fetchData(0);
      handleClose();
    } catch (err) {
      setError('Failed to add expert. ' + err.message);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleClickOpen}>
        Add Expert
      </Button>
      <Modal
        open={open}
        modalTitle="Add Expert"
        handleClose={handleClose}
        width="md">
        {error && <Alert severity="error">{error}</Alert>}
        <ExpertAdviceForm onSubmit={handleSubmit} />
      </Modal>
    </>
  );
};

export default AddExpertAdvice;
